/**
 * Build-a-Box PDP — Accordion, upsell sync, ADD TO BOX, tier slider,
 * dynamic perks, gallery thumbs, scroll CTA
 */
(function initMealPdp() {
  'use strict';
  if (window.__babDisposePdp) window.__babDisposePdp();
  var lifecycle = new AbortController();
  var observers = [];
  function watchMutations(callback) {
    var observer = new MutationObserver(callback);
    observers.push(observer);
    return observer;
  }
  window.__babDisposePdp = function () {
    if (trappedModal) closeAllModals();
    lifecycle.abort();
    observers.forEach(function (observer) { observer.disconnect(); });
  };
  if (window.Shopify && window.Shopify.designMode && !window.__babDisposePdpEditor) {
    window.__babDisposePdpEditor = true;
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.querySelector('#build-a-box')) initMealPdp();
    });
  }


  var pdp = document.querySelector('.bab-pdp');
  if (!pdp) return;

  var configEl = document.getElementById('build-a-box-config');
  var CONFIG;
  try { CONFIG = JSON.parse(configEl.textContent); } catch (e) { return; }
  var bottleAvailable = Boolean(CONFIG.upsell && CONFIG.upsell.available === true);
  var isEverSubscriber = Boolean(CONFIG.subscriptionOffer && CONFIG.subscriptionOffer.isEverSubscriber);

  /* ===== Gallery — open lightbox on image click ===== */
  var media = CONFIG.media || [];

  // Desktop thumbnails → open lightbox at that index
  var thumbs = pdp.querySelectorAll('[data-bab-pdp-thumb]');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var idx = parseInt(thumb.dataset.babPdpThumb, 10);
      if (window.PdpLightbox) window.PdpLightbox.open(media, idx);
    });
  });

  // Desktop main image → open lightbox at index 0
  var mainImg = pdp.querySelector('.bab-pdp__gallery-image');
  if (mainImg) {
    mainImg.addEventListener('click', function () {
      if (window.PdpLightbox) window.PdpLightbox.open(media, 0);
    });
  }

  // Mobile carousel slides → open lightbox at slide's index
  var carouselSlides = pdp.querySelectorAll('.bab-pdp__carousel-slide img');
  carouselSlides.forEach(function (img, idx) {
    img.addEventListener('click', function () {
      if (window.PdpLightbox) window.PdpLightbox.open(media, idx);
    });
  });

  /* ===== Smooth scroll for "Choose Your Flavors" CTA ===== */
  var scrollCta = pdp.querySelector('[data-bab-pdp-scroll-cta]');
  if (scrollCta) {
    scrollCta.addEventListener('click', function (e) {
      e.preventDefault();
      var target = document.getElementById('bab-pdp-flavors');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ===== Accordion ===== */
  var accordionTriggers = pdp.querySelectorAll('[data-bab-accordion-trigger]');
  accordionTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('[data-bab-accordion-item]');
      if (!item) return;
      var wasOpen = item.classList.contains('is-open');
      // Close all — aria-expanded is reset alongside is-open on every item, so
      // the panels this closes stop claiming to be open.
      pdp.querySelectorAll('[data-bab-accordion-item]').forEach(function (el) {
        el.classList.remove('is-open');
        var otherTrigger = el.querySelector('[data-bab-accordion-trigger]');
        if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
      });
      // Toggle clicked
      if (!wasOpen) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ===== Upsell toggle sync (hero <-> sidebar) ===== */
  var heroToggle = pdp.querySelector('[data-bab-pdp-upsell-toggle]');
  var sidebarToggle = pdp.querySelector('[data-bab-pdp-upsell-toggle-sidebar]');

  function syncUpsellToggles(source, target) {
    if (!source || !target) return;
    source.addEventListener('change', function () {
      target.checked = source.checked && bottleAvailable;
      source.checked = target.checked;
    });
  }

  syncUpsellToggles(heroToggle, sidebarToggle);
  syncUpsellToggles(sidebarToggle, heroToggle);

  [heroToggle, sidebarToggle].forEach(function (toggle) {
    if (!toggle) return;
    toggle.disabled = !bottleAvailable;
    if (!bottleAvailable) toggle.checked = false;
  });

  // Re-render summary total when upsell toggle changes
  function onUpsellToggleChange() {
    var summaryTotal = pdp.querySelector('[data-bab-summary-total]');
    if (!summaryTotal) return;
    // Trigger a re-render by simulating a minor state change
    var selectedTier = pdp.querySelector('[data-bab-tier].is-selected');
    if (selectedTier) selectedTier.click();
  }
  if (sidebarToggle) sidebarToggle.addEventListener('change', onUpsellToggleChange);
  if (heroToggle) heroToggle.addEventListener('change', onUpsellToggleChange);

  /* ===== ADD TO BOX button → proxy to increment ===== */
  pdp.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-bab-add-to-box]');
    if (!addBtn) return;
    e.preventDefault();
    e.stopPropagation();
    var card = addBtn.closest('[data-bab-flavor]');
    if (!card) return;
    var incrementBtn = card.querySelector('[data-bab-increment]');
    if (incrementBtn) incrementBtn.click();
  });

  /* ===== Tier slider positioning ===== */
  var tierSlider = pdp.querySelector('[data-bab-tier-slider]');
  var sliderFill = pdp.querySelector('[data-bab-tier-slider-fill]');
  var tierMarks = pdp.querySelectorAll('[data-bab-tier-mark]');

  // Mark positions (percentage of track): 12 → 33.33%, 18 → 66.66%, 30 → 100%
  var tierPositions = { 12: 33.33, 18: 66.66, 30: 100 };

  function updateTierSlider(totalSelected) {
    if (!tierSlider) return;

    // Segmented fill: 0-12 → 0-33.33%, 12-18 → 33.33-66.66%, 18-30 → 66.66-100%
    var pct;
    if (totalSelected <= 12) {
      pct = (totalSelected / 12) * 33.33;
    } else if (totalSelected <= 18) {
      pct = 33.33 + ((totalSelected - 12) / 6) * 33.33;
    } else {
      pct = 66.66 + ((totalSelected - 18) / 12) * 33.34;
    }
    pct = Math.min(pct, 100);

    if (sliderFill) sliderFill.style.width = pct + '%';

    tierMarks.forEach(function (mark) {
      var markTier = parseInt(mark.dataset.babTierMark, 10);
      var markPct = tierPositions[markTier] || 100;
      mark.classList.toggle('is-reached', pct >= markPct);
      mark.classList.toggle('is-active', totalSelected === markTier);
    });
  }

  /* ===== Tier per-meal price update ===== */
  function updateTierPerMealPrices(purchaseType) {
    CONFIG.variants.forEach(function (v) {
      var span = pdp.querySelector('[data-bab-tier-per-meal="' + v.quantity + '"]');
      if (!span) return;
      var priceCents;
      if (purchaseType === 'subscribe' && CONFIG.subscriptionPricing[String(v.quantity)]) {
        priceCents = CONFIG.subscriptionPricing[String(v.quantity)].firstOrder;
      } else {
        priceCents = v.price;
      }
      var perMeal = priceCents / v.quantity / 100;
      span.textContent = '$' + perMeal.toFixed(2);
    });
  }

  // Initial population (subscribe is default)
  updateTierPerMealPrices('subscribe');

  // Update on purchase type change
  var purchaseTypeBtns = pdp.querySelectorAll('[data-bab-purchase-type]');
  purchaseTypeBtns.forEach(function (btn) {
    watchMutations(function () {
      if (btn.classList.contains('is-selected')) {
        var type = btn.dataset.babPurchaseType === 'subscribe' ? 'subscribe' : 'onetime';
        updateTierPerMealPrices(type);
        updateSidebarForPurchaseType(type);
      }
    }).observe(btn, { attributes: true, attributeFilter: ['class'] });
  });

  /* ===== Dynamic perk text ===== */
  var perkFirst = pdp.querySelector('[data-bab-perk-first]');
  var perkFuture = pdp.querySelector('[data-bab-perk-future]');

  function updatePerkText(tier) {
    if (!CONFIG.subscriptionPricing) return;
    var pricing = CONFIG.subscriptionPricing[String(tier)];
    if (!pricing) return;

    var variant = CONFIG.variants.find(function (v) { return v.quantity === tier; });
    if (!variant) return;

    var firstSavings = variant.price - pricing.firstOrder;
    var recurringSavings = variant.price - pricing.recurring;

    if (perkFirst) {
      perkFirst.textContent = isEverSubscriber
        ? '5% OFF EVERY BOX'
        : '$' + (firstSavings / 100).toFixed(0) + ' OFF YOUR FIRST-EVER BOX';
    }
    if (perkFuture) perkFuture.textContent = '5% OFF ADDITIONAL AND FUTURE BOXES';
  }

  /* ===== "X MEALS IN YOUR BOX" subtitle sync ===== */
  var subtitleCount = pdp.querySelector('[data-bab-pdp-subtitle-count]');

  function updateSubtitleCount(totalSelected) {
    if (subtitleCount) subtitleCount.textContent = totalSelected;
  }

  /* ===== Dynamic upsell text ("ADD X MORE AND SAVE $Y") ===== */
  var upsellText = pdp.querySelector('[data-bab-summary-upsell-text]');

  function updateUpsellText(totalSelected) {
    if (!upsellText) return;

    var milestones = [12, 18, 30];

    // Find next milestone above current count
    var nextTier = null;
    for (var i = 0; i < milestones.length; i++) {
      if (milestones[i] > totalSelected) { nextTier = milestones[i]; break; }
    }

    if (!nextTier) {
      upsellText.style.display = 'none';
      return;
    }

    var remaining = nextTier - totalSelected;

    // Find current tier for pricing comparison
    var currentTier = null;
    for (var j = milestones.length - 1; j >= 0; j--) {
      if (milestones[j] <= totalSelected) { currentTier = milestones[j]; break; }
    }
    if (!currentTier) currentTier = milestones[0];

    var currentPricing = CONFIG.subscriptionPricing[String(currentTier)];
    var nextPricing = CONFIG.subscriptionPricing[String(nextTier)];
    if (!currentPricing || !nextPricing) {
      upsellText.style.display = 'none';
      return;
    }

    var currentPerMeal = currentPricing.firstOrder / currentTier;
    var nextPerMeal = nextPricing.firstOrder / nextTier;
    var totalSavings = Math.round((currentPerMeal - nextPerMeal) * nextTier);

    if (totalSavings > 0) {
      upsellText.textContent = 'ADD ' + remaining + ' MORE PACKS AND SAVE $' + (totalSavings / 100).toFixed(2);
      upsellText.style.display = 'block';
    } else {
      upsellText.style.display = 'none';
    }
  }

  /* ===== Summary perk savings (all instances: original + between-buttons) ===== */
  function updateSummaryPerkSavings(tier) {
    if (!CONFIG.subscriptionPricing) return;
    var pricing = CONFIG.subscriptionPricing[String(tier)];
    if (!pricing) return;
    var variant = CONFIG.variants.find(function (v) { return v.quantity === tier; });
    if (!variant) return;
    var firstSavings = variant.price - pricing.firstOrder;
    var futureSavings = variant.price - pricing.recurring;
    var firstText = isEverSubscriber
      ? '5% off every box'
      : '$' + (firstSavings / 100).toFixed(0) + ' off your first-ever box';
    var futureText = '5% off additional and future boxes';
    // Update ALL instances (original perks + between-buttons perks)
    pdp.querySelectorAll('[data-bab-summary-perk-first]').forEach(function (el) { el.textContent = firstText; });
    pdp.querySelectorAll('[data-bab-summary-perk-future]').forEach(function (el) { el.textContent = futureText; });
  }

  /* ===== Observe state changes from shared build-a-box.js ===== */
  // Watch tier selections
  var tierCards = pdp.querySelectorAll('[data-bab-tier]');
  tierCards.forEach(function (card) {
    watchMutations(function () {
      if (card.classList.contains('is-selected')) {
        var tier = parseInt(card.dataset.babTier, 10);
        updatePerkText(tier);
        updateSummaryPerkSavings(tier);
        updateMobilePerkText(tier);
      }
    }).observe(card, { attributes: true, attributeFilter: ['class'] });
  });

  // Watch progress count for tier slider + subtitle + mobile bar updates
  var progressCount = pdp.querySelector('[data-bab-progress-count]');

  /* ===== Mobile bar elements ===== */
  var mobileBar = document.querySelector('[data-bab-mobile-bar]');
  var mobileFill = mobileBar ? mobileBar.querySelector('[data-bab-mobile-slider-fill]') : null;
  var mobileMarks = mobileBar ? mobileBar.querySelectorAll('[data-bab-mobile-mark]') : [];
  var mobileCount = mobileBar ? mobileBar.querySelector('[data-bab-mobile-count]') : null;
  var mobileSlider = mobileBar ? mobileBar.querySelector('[data-bab-mobile-slider]') : null;
  var mobileBtn = mobileBar ? mobileBar.querySelector('[data-bab-mobile-btn]') : null;
  var mobilePerkFirst = mobileBar ? mobileBar.querySelector('[data-bab-mobile-perk-first]') : null;
  var MILESTONES = [12, 18, 30];
  var mobileBarTotalSelected = 0;

  /* Show/hide mobile bar based on scroll position */
  var flavorSection = document.getElementById('bab-pdp-flavors');
  function checkMobileBarVisibility() {
    if (!mobileBar || !flavorSection) return;
    var flavorTop = flavorSection.getBoundingClientRect().top;
    var shouldShow = flavorTop <= window.innerHeight || mobileBarTotalSelected > 0;
    mobileBar.classList.toggle('bab-mobile-bar--hidden', !shouldShow);
  }

  if (flavorSection) {
    window.addEventListener('scroll', checkMobileBarVisibility, { passive: true, signal: lifecycle.signal });
    checkMobileBarVisibility();
  }

  function updateMobileBar(totalSelected) {
    if (!mobileBar) return;
    mobileBarTotalSelected = totalSelected;

    // Show/hide progress bar and count based on whether meals are being added
    var hasMeals = totalSelected > 0;
    if (mobileSlider) mobileSlider.classList.toggle('bab-mobile-bar__slider--hidden', !hasMeals);
    if (mobileCount) mobileCount.classList.toggle('bab-mobile-bar__count--hidden', !hasMeals);

    // Progress fill — stop before each milestone label's left edge, cover it at the milestone
    var trackEl = mobileSlider ? mobileSlider.querySelector('.bab-mobile-bar__track') : null;
    var trackWidth = trackEl ? trackEl.offsetWidth : 300;
    var labelW = 24; // mark-label width in px
    var lPct = (labelW / trackWidth) * 100;

    var pct;
    if (totalSelected === 0) {
      pct = 0;
    } else if (totalSelected < 12) {
      pct = (totalSelected / 12) * (33.33 - lPct);
    } else if (totalSelected === 12) {
      pct = 33.33;
    } else if (totalSelected < 18) {
      pct = 33.33 + ((totalSelected - 12) / 6) * (33.33 - lPct);
    } else if (totalSelected === 18) {
      pct = 66.66;
    } else if (totalSelected < 30) {
      pct = 66.66 + ((totalSelected - 18) / 12) * (33.34 - lPct);
    } else {
      pct = 100;
    }
    pct = Math.min(pct, 100);
    if (mobileFill) mobileFill.style.width = pct + '%';

    // Mark states
    mobileMarks.forEach(function (mark) {
      var markTier = parseInt(mark.dataset.babMobileMark, 10);
      var markPct = tierPositions[markTier] || 100;
      mark.classList.toggle('is-reached', pct >= markPct);
      var isActive = markTier === 0 ? totalSelected > 0 : totalSelected === markTier;
      mark.classList.toggle('is-active', isActive);
    });

    // Meal count text
    if (mobileCount) {
      mobileCount.textContent = totalSelected + ' MEALS IN YOUR BOX';
    }

    // Button label based on milestone. The button is never marked disabled —
    // below a milestone it scrolls to the flavor picker, which is a real action
    // — so the label alone carries the state, matching the desktop button.
    // The dimmed look used to come from a [aria-disabled="true"] CSS rule; with
    // the attribute gone it is applied here, in the same render path.
    var isAtMilestone = MILESTONES.indexOf(totalSelected) !== -1;
    var validBox = isAtMilestone && window.__babState && window.__babState.isValid;
    if (mobileBtn) {
      mobileBtn.textContent = validBox ? 'Go to Checkout' : isAtMilestone ? 'Review your flavors' : 'Choose 12, 18, or 30 Meals';
      mobileBtn.style.opacity = validBox ? '' : '0.4';
    }

    // Re-check visibility (meals > 0 should always show bar)
    checkMobileBarVisibility();
  }

  function updateMobilePerkText(tier) {
    if (!mobilePerkFirst || !CONFIG.subscriptionPricing[String(tier)]) return;
    var pricing = CONFIG.subscriptionPricing[String(tier)];
    var variant = CONFIG.variants.find(function (v) { return v.quantity === tier; });
    if (!variant) return;
    var firstSavings = variant.price - pricing.firstOrder;
    mobilePerkFirst.textContent = isEverSubscriber
      ? '5% off every box'
      : '$' + (firstSavings / 100).toFixed(0) + ' off your first-ever box';
  }

  if (progressCount) {
    watchMutations(function () {
      var text = progressCount.textContent; // "X / Y"
      var parts = text.split('/').map(function (s) { return parseInt(s.trim(), 10); });
      if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
        var totalSelected = parts[0];
        updateTierSlider(totalSelected);
        updateSubtitleCount(totalSelected);
        updateUpsellText(totalSelected);
        updateMobileBar(totalSelected);
        // Sync desktop and dual checkout button disabled state
        var isAtMilestone = MILESTONES.indexOf(totalSelected) !== -1;
        var validBox = isAtMilestone && window.__babState && window.__babState.isValid;
        var canCheckout = validBox && pdp.getAttribute('aria-busy') !== 'true';
        var subBtn = pdp.querySelector('[data-bab-checkout-subscribe]');
        var oneBtn = pdp.querySelector('[data-bab-checkout-onetime]');
        if (subBtn) subBtn.disabled = !canCheckout;
        if (oneBtn) oneBtn.disabled = !canCheckout;
        if (addToCartBtn) {
          addToCartBtn.disabled = !canCheckout;
          addToCartBtn.textContent = validBox ? 'Go to Checkout' : isAtMilestone ? 'Review your flavors' : 'Choose 12, 18, or 30 Meals';
        }
      }
    }).observe(progressCount, { childList: true, characterData: true, subtree: true });
  }

  /* ===== Populate summary upsell from config ===== */
  // The bottle is no longer discounted — show a single full price, no compare.
  if (CONFIG.upsell) {
    var upsellThumb = pdp.querySelector('[data-bab-summary-upsell-thumb]');
    var upsellName = pdp.querySelector('[data-bab-summary-upsell-name]');
    var upsellDprice = pdp.querySelector('[data-bab-summary-upsell-dprice]');
    if (upsellName) upsellName.textContent = CONFIG.upsell.title;
    if (upsellDprice) upsellDprice.textContent = '$' + (CONFIG.upsell.price / 100).toFixed(2).replace(/\.00$/, '');
    if (upsellThumb && CONFIG.upsell.image) {
      upsellThumb.innerHTML = '<img src="' + CONFIG.upsell.image + '" alt="" width="52" height="52" loading="lazy">';
    }
  }

  /* ===== Auto-select 18 meals + Subscribe on load ===== */
  var defaultTier = pdp.querySelector('[data-bab-tier="18"]') || pdp.querySelector('[data-bab-tier="12"]');
  if (defaultTier) {
    defaultTier.click();
    var defaultTierValue = parseInt(defaultTier.dataset.babTier, 10);
    updatePerkText(defaultTierValue);
    updateSummaryPerkSavings(defaultTierValue);
    updateMobilePerkText(defaultTierValue);
  }

  /* ===== One-click combos, synchronized with the selected box size ===== */
  var comboPicker = pdp.querySelector('[data-bab-combos]');
  // Client preview on production: never persist access for ordinary visits.
  var comboPreviewEnabled = new URLSearchParams(window.location.search).get('meal_combos') === '1';
  if (comboPreviewEnabled && comboPicker && window.AlphaMealCombos && window.__babApplySelections &&
      (!CONFIG.mealCombos || CONFIG.mealCombos.enabled !== false)) {
    var comboButtons = comboPicker.querySelectorAll('[data-bab-combo]');
    var comboStatus = comboPicker.querySelector('[data-bab-combo-status]');
    var comboQuantity = comboPicker.querySelector('[data-bab-combo-quantity]');
    var activeCombo = null;
    var lastComboTier = window.__babState.quantityTier;
    var lastComboPurchaseType = window.__babState.purchaseType;
    var lastComboSellingPlan = window.__babState.sellingPlanId;
    var applyingCombo = false;
    var comboNames = { 'perfect-split': 'Perfect Split', 'surprise-me': 'Surprise me', 'basic-bro': 'Basic Bro' };
    var comboDescriptions = {};
    comboButtons.forEach(function (button) {
      var description = button.querySelector('.bab-combo__description');
      comboDescriptions[button.dataset.babCombo] = description ? description.textContent : '';
    });

    function recipe(id, preview) {
      var state = window.__babState;
      return window.AlphaMealCombos.create(id, window.__babConfig || CONFIG, state.quantityTier,
        state, preview ? function () { return 0; } : undefined);
    }

    function renderComboPicker() {
      if (comboQuantity) comboQuantity.textContent = window.__babState.quantityTier || '';
      var busy = pdp.getAttribute('aria-busy') === 'true';
      comboButtons.forEach(function (button) {
        var id = button.dataset.babCombo;
        var result = recipe(id, true);
        button.disabled = busy || Boolean(result.error);
        button.classList.toggle('is-selected', activeCombo === id);
        button.setAttribute('aria-pressed', activeCombo === id ? 'true' : 'false');
        var description = button.querySelector('.bab-combo__description');
        if (description) description.textContent = result.error || comboDescriptions[id];
      });
    }

    function applyCombo(id) {
      var result = recipe(id, false);
      if (result.error) {
        activeCombo = null;
        if (comboStatus) comboStatus.textContent = result.error + ' Your current selections have been kept.';
        renderComboPicker();
        return;
      }
      applyingCombo = true;
      var applied;
      try { applied = window.__babApplySelections(result.selections); }
      finally { applyingCombo = false; }
      activeCombo = applied ? id : null;
      if (comboStatus) comboStatus.textContent = applied
        ? comboNames[id] + ' filled your ' + window.__babState.quantityTier + '-meal box. Adjust any flavor below.'
        : 'Flavor availability changed. Please choose your combo again.';
      renderComboPicker();
    }

    comboPicker.addEventListener('click', function (event) {
      var button = event.target.closest('[data-bab-combo]');
      if (!button || button.disabled || pdp.getAttribute('aria-busy') === 'true') return;
      applyCombo(button.dataset.babCombo);
    }, { signal: lifecycle.signal });

    pdp.addEventListener('bab:state-change', function (event) {
      var state = window.__babState;
      var reason = event.detail && event.detail.reason;
      var contextChanged = lastComboTier !== state.quantityTier || lastComboPurchaseType !== state.purchaseType ||
        lastComboSellingPlan !== state.sellingPlanId;
      lastComboTier = state.quantityTier;
      lastComboPurchaseType = state.purchaseType;
      lastComboSellingPlan = state.sellingPlanId;
      if (applyingCombo) return;
      if (reason === 'selection' && activeCombo) {
        activeCombo = null;
        if (comboStatus) comboStatus.textContent = 'Custom mix. Keep adjusting your flavors below.';
      } else if (activeCombo && contextChanged && (reason === 'tier' || reason === 'purchase-type')) {
        applyCombo(activeCombo);
        return;
      }
      renderComboPicker();
    }, { signal: lifecycle.signal });

    comboPicker.hidden = false;
    renderComboPicker();
  }

  /* ===== Summary item controls (event delegation for sidebar +/- buttons) ===== */
  var summaryItems = pdp.querySelector('[data-bab-summary-items]');
  if (summaryItems) {
    summaryItems.addEventListener('click', function (e) {
      var ctrl = e.target.closest('[data-bab-summary-ctrl]');
      if (!ctrl) return;
      e.stopPropagation();
      var handle = ctrl.dataset.babSummaryCtrl;
      var action = ctrl.dataset.babSummaryAction;
      // Find the matching flavor card and click its increment/decrement
      var flavorCard = pdp.querySelector('[data-flavor-handle="' + handle + '"]');
      if (!flavorCard) return;
      if (action === 'increment') {
        var inc = flavorCard.querySelector('[data-bab-increment]');
        if (inc) inc.click();
      } else if (action === 'decrement') {
        var dec = flavorCard.querySelector('[data-bab-decrement]');
        if (dec) dec.click();
      }
    });
  }

  /* =======================================================================
     Conditional Checkout Flow
     —————————————————————————————————————————————————————————————————————
     Adapts the sidebar and checkout behavior based on subscribe vs one-time:
     - Subscribe: single "Go to Checkout" button + bottle upsell popup
     - One-time:  dual buttons + subscription conversion popup
     ======================================================================= */

  /* ----- Conditional sidebar DOM refs ----- */
  var addToCartBtn = pdp.querySelector('[data-bab-add-to-cart]');
  var onetimeButtonsWrap = pdp.querySelector('[data-bab-onetime-buttons]');
  var checkoutSubscribeBtn = pdp.querySelector('[data-bab-checkout-subscribe]');
  var checkoutOnetimeBtn = pdp.querySelector('[data-bab-checkout-onetime]');
  var perksOriginal = pdp.querySelector('[data-bab-perks-original]');
  var saveLabel = pdp.querySelector('[data-bab-save-label]');

  /* ----- Modal DOM refs ----- */
  var subscribeModal = document.querySelector('[data-bab-modal-subscribe]');
  var bottleModal = document.querySelector('[data-bab-modal-bottle]');
  var sectionEl = document.getElementById('build-a-box');

  /* ----- updateSidebarForPurchaseType ----- */
  function updateSidebarForPurchaseType(purchaseType) {
    var isOnetime = (purchaseType === 'onetime');

    // 1. Toggle button visibility
    if (addToCartBtn) addToCartBtn.style.display = isOnetime ? 'none' : '';
    if (onetimeButtonsWrap) onetimeButtonsWrap.style.display = isOnetime ? '' : 'none';

    // 2. Toggle perks position
    if (perksOriginal) perksOriginal.style.display = isOnetime ? 'none' : '';

    // 3 & 4. Bottle pricing display. The bottle is no longer discounted, so both
    //   the sidebar and hero upsell always show the single full price regardless
    //   of purchase type — no strikethrough compare, no "save" messaging.
    var fullBottlePrice = '$' + (CONFIG.upsell.price / 100).toFixed(2).replace(/\.00$/, '');
    var sidebarDprice = pdp.querySelector('[data-bab-summary-upsell-dprice]');
    if (sidebarDprice) sidebarDprice.textContent = fullBottlePrice;
    var heroPrice = pdp.querySelector('[data-bab-pdp-upsell-price]');
    if (heroPrice) heroPrice.textContent = fullBottlePrice;

    // 5. Update upsell text behavior
    if (isOnetime && upsellText) {
      upsellText.textContent = isEverSubscriber
        ? 'SAVE 5% ON EVERY SUBSCRIPTION BOX'
        : 'SAVE 20% ON YOUR FIRST-EVER BOX';
      upsellText.classList.add('bab-summary__upsell-text--onetime');
      upsellText.style.display = 'block';
    } else if (upsellText) {
      upsellText.classList.remove('bab-summary__upsell-text--onetime');
      // Re-run the normal upsell text logic
      var currentCount = progressCount ? parseInt(progressCount.textContent, 10) : 0;
      if (!isNaN(currentCount)) updateUpsellText(currentCount);
    }

    // 6. Dual-button prices (incl. bottle add-on) are computed in
    //    build-a-box.js renderSummary, the single source of truth that runs on
    //    every tier / purchase-type / flavor / bottle-toggle change.
  }

  /* ----- Modal focus management -----------------------------------------
     Both checkout modals are role="dialog" aria-modal="true" but never moved
     focus, so a keyboard or screen-reader customer was left behind the overlay
     — tabbing through the page underneath with no way to reach the buttons
     that decide the order. openModalFocus() remembers the control that opened
     the dialog, moves focus into it and traps Tab; releaseModalFocus() (called
     from closeAllModals, which every close path goes through) puts focus back —
     or, when that control is gone by then, onto a checkout control that is
     still on screen. Escape handling already exists further down — untouched.
     --------------------------------------------------------------------- */
  var modalReturnFocusEl = null;
  var trappedModal = null;
  var FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function getFocusableIn(modal) {
    var nodes = modal.querySelectorAll(FOCUSABLE_SELECTOR);
    var visible = [];
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      // Skip anything not rendered: a display:none subtree has no box, so it
      // reports zero size and no client rects.
      if (el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0) {
        visible.push(el);
      }
    }
    return visible;
  }

  function onModalTrapKeydown(e) {
    if (e.key !== 'Tab' || !trappedModal) return;
    var focusable = getFocusableIn(trappedModal);
    if (!focusable.length) {
      e.preventDefault();
      return;
    }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    var active = document.activeElement;
    var inside = trappedModal.contains(active);

    if (e.shiftKey) {
      if (!inside || active === first) {
        e.preventDefault();
        last.focus();
      }
    } else if (!inside || active === last) {
      e.preventDefault();
      first.focus();
    }
  }

  // Can this element actually take focus right now? A display:none subtree has
  // no box, so it reports zero size and no client rects.
  function isFocusableNow(el) {
    return !!(el && el.nodeType === 1 && typeof el.focus === 'function' &&
      document.contains(el) && !el.disabled &&
      (el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0));
  }

  /* Where focus goes when there is nothing sensible to go back to. The one-time
     checkout buttons are hidden the instant the customer converts to subscribe,
     which blurs focus to <body> in the middle of the subscribe → bottle
     handoff, so the remembered opener is gone (or was never captured) by the
     time the second dialog closes. Land on whichever checkout control is
     actually on screen instead of dumping a keyboard customer at the top of
     the document. */
  function fallbackFocusTarget() {
    var candidates = [addToCartBtn, checkoutSubscribeBtn, checkoutOnetimeBtn, mobileBtn];
    for (var i = 0; i < candidates.length; i++) {
      if (isFocusableNow(candidates[i])) return candidates[i];
    }
    return null;
  }

  function openModalFocus(modal) {
    if (!modal) return;
    var opener = document.activeElement;
    // <body> is not a return target (a mouse click in Safari, and any blur
    // caused by hiding the control mid-flow, leave focus there), and neither is
    // a control inside a dialog — returning there would trap the customer.
    // releaseModalFocus falls back when there is nothing worth storing.
    modalReturnFocusEl = (opener && opener !== document.body && opener.closest &&
      !opener.closest('.bab-checkout-modal')) ? opener : null;
    trappedModal = modal;
    // Re-adding the same listener reference is a no-op, so repeated opens
    // cannot stack duplicate handlers.
    document.addEventListener('keydown', onModalTrapKeydown, { capture: true, signal: lifecycle.signal });
    var focusable = getFocusableIn(modal);
    if (focusable.length) focusable[0].focus();
  }

  function releaseModalFocus() {
    // closeAllModals also runs on a stray Escape with nothing open; don't move
    // focus in that case.
    if (!trappedModal) return;
    document.removeEventListener('keydown', onModalTrapKeydown, true);
    trappedModal = null;
    var returnTo = modalReturnFocusEl;
    modalReturnFocusEl = null;
    // The remembered control can be gone by the time the dialog closes — see
    // fallbackFocusTarget.
    if (!isFocusableNow(returnTo)) returnTo = fallbackFocusTarget();
    // On the paths that proceed to checkout the page navigates away, so this
    // simply does nothing visible — but it must never throw.
    if (returnTo) {
      try { returnTo.focus(); } catch (err) { /* element became unfocusable */ }
    }
  }

  /* ----- Modal helpers ----- */
  function showSubscribeModal() {
    if (!subscribeModal) return;
    // Update dynamic pricing in modal
    var state = window.__babState;
    var tier = window.__babGetCheckoutTier ? window.__babGetCheckoutTier() : state ? state.quantityTier : null;
    if (tier && window.__babGetSubscriptionPricing) {
      var pricing = window.__babGetSubscriptionPricing(tier);
      var variant = CONFIG.variants.find(function (v) { return v.quantity === tier; });
      if (pricing && variant) {
        var firstSavings = (variant.price - pricing.firstOrder) / 100;
        var futureSavings = (variant.price - pricing.recurring) / 100;
        var modalPerkFirst = subscribeModal.querySelector('[data-bab-modal-perk-first]');
        var modalPerkFuture = subscribeModal.querySelector('[data-bab-modal-perk-future]');
        if (modalPerkFirst) {
          modalPerkFirst.textContent = isEverSubscriber
            ? '5% OFF EVERY BOX'
            : '$' + firstSavings.toFixed(0) + ' OFF YOUR FIRST-EVER BOX';
        }
        if (modalPerkFuture) modalPerkFuture.textContent = '5% OFF ADDITIONAL AND FUTURE BOXES';
      }
    }
    subscribeModal.style.display = '';
    document.body.style.overflow = 'hidden';
    openModalFocus(subscribeModal);
  }

  function showBottleModal() {
    if (!bottleAvailable || !bottleModal) return;
    bottleModal.style.display = '';
    document.body.style.overflow = 'hidden';
    openModalFocus(bottleModal);
  }

  function closeAllModals() {
    if (subscribeModal) subscribeModal.style.display = 'none';
    if (bottleModal) bottleModal.style.display = 'none';
    document.body.style.overflow = '';
    releaseModalFocus();
  }

  /* ----- Helper: check bottle and proceed to checkout ----- */
  function checkBottleThenCheckout() {
    var toggle = document.querySelector('[data-bab-pdp-upsell-toggle]') ||
                 document.querySelector('[data-bab-pdp-upsell-toggle-sidebar]');
    if (bottleAvailable && bottleModal && toggle && !toggle.checked) {
      showBottleModal();
    } else {
      if (window.__babAddToCart) window.__babAddToCart();
    }
  }

  /* ----- Helper: switch purchase type to subscribe ----- */
  function switchToSubscribe() {
    var subscribeCard = pdp.querySelector('[data-bab-purchase-type="subscribe"]');
    if (subscribeCard && !subscribeCard.classList.contains('is-selected')) {
      subscribeCard.click();
    }
  }

  /* ----- Checkout interception (subscribe path: "Go to Checkout" button) ----- */
  if (sectionEl) {
    sectionEl.addEventListener('bab:beforeAddToCart', function (e) {
      var state = window.__babState;
      if (!state) return;

      if (state.purchaseType === 'subscribe') {
        // Check if bottle needs upsell popup
        var toggle = document.querySelector('[data-bab-pdp-upsell-toggle]') ||
                     document.querySelector('[data-bab-pdp-upsell-toggle-sidebar]');
        if (bottleAvailable && bottleModal && toggle && !toggle.checked) {
          e.preventDefault();
          showBottleModal();
          return;
        }
        // Bottle is toggled or no toggle — proceed normally
        return;
      }

      // One-time: intercept and show subscription conversion popup
      e.preventDefault();
      showSubscribeModal();
    });
  }

  /* ----- Dual button handlers ----- */

  // "CHECKOUT WITH SUBSCRIPTION" — convert + check bottle
  if (checkoutSubscribeBtn) {
    checkoutSubscribeBtn.addEventListener('click', function () {
      var state = window.__babState;
      if (!state || !state.isValid) return;
      switchToSubscribe();
      // Short delay for state to settle after click-triggered re-render
      setTimeout(function () {
        checkBottleThenCheckout();
      }, 50);
    });
  }

  // "CONTINUE WITH ONE-TIME" — show subscription conversion popup
  if (checkoutOnetimeBtn) {
    checkoutOnetimeBtn.addEventListener('click', function () {
      var state = window.__babState;
      if (!state || !state.isValid) return;
      showSubscribeModal();
    });
  }

  /* ----- Subscribe modal button handlers ----- */
  if (subscribeModal) {
    // "CHECKOUT WITH 20% SAVINGS" — convert to subscribe, check bottle
    var acceptSubscribe = subscribeModal.querySelector('[data-bab-modal-accept-subscribe]');
    if (acceptSubscribe) {
      acceptSubscribe.addEventListener('click', function () {
        closeAllModals();
        switchToSubscribe();
        setTimeout(function () {
          checkBottleThenCheckout();
        }, 50);
      });
    }

    // "CONTINUE WITH ONE-TIME PURCHASE" — proceed as one-time
    var declineSubscribe = subscribeModal.querySelector('[data-bab-modal-decline-subscribe]');
    if (declineSubscribe) {
      declineSubscribe.addEventListener('click', function () {
        closeAllModals();
        // Ensure state is one-time
        var onetimeCard = pdp.querySelector('[data-bab-purchase-type="onetime"]');
        if (onetimeCard && !onetimeCard.classList.contains('is-selected')) onetimeCard.click();
        if (window.__babAddToCart) window.__babAddToCart();
      });
    }

    // Close buttons (overlay + X)
    subscribeModal.querySelectorAll('[data-bab-modal-close]').forEach(function (el) {
      el.addEventListener('click', closeAllModals);
    });
  }

  /* ----- Bottle modal button handlers ----- */
  if (bottleModal) {
    // "ADD METAL SHAKER BOTTLE" — toggle bottle on + checkout
    var acceptBottle = bottleModal.querySelector('[data-bab-modal-accept-bottle]');
    if (acceptBottle) {
      acceptBottle.addEventListener('click', function () {
        closeAllModals();
        if (!bottleAvailable) {
          if (window.__babAddToCart) window.__babAddToCart();
          return;
        }
        var ht = pdp.querySelector('[data-bab-pdp-upsell-toggle]');
        var st = pdp.querySelector('[data-bab-pdp-upsell-toggle-sidebar]');
        if (ht) { ht.checked = true; ht.dispatchEvent(new Event('change')); }
        if (st) { st.checked = true; st.dispatchEvent(new Event('change')); }
        setTimeout(function () {
          if (window.__babAddToCart) window.__babAddToCart();
        }, 100);
      });
    }

    // "NO, THANK YOU" — proceed without bottle
    var declineBottle = bottleModal.querySelector('[data-bab-modal-decline-bottle]');
    if (declineBottle) {
      declineBottle.addEventListener('click', function () {
        closeAllModals();
        if (window.__babAddToCart) window.__babAddToCart();
      });
    }

    // Close buttons (overlay + X)
    bottleModal.querySelectorAll('[data-bab-modal-close]').forEach(function (el) {
      el.addEventListener('click', closeAllModals);
    });
  }

  /* ----- Escape key to close modals ----- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllModals();
  }, { signal: lifecycle.signal });

  /* ===== Stars text — shrink to fit one line ===== */
  var starsText = pdp.querySelector('.bab-pdp__stars-text');
  if (starsText) {
    function fitStarsText() {
      starsText.style.fontSize = '';
      var available = starsText.parentElement.offsetWidth;
      while (starsText.scrollWidth > available && parseFloat(getComputedStyle(starsText).fontSize) > 8) {
        starsText.style.fontSize = (parseFloat(getComputedStyle(starsText).fontSize) - 0.5) + 'px';
      }
    }
    fitStarsText();
    window.addEventListener('resize', fitStarsText, { signal: lifecycle.signal });
  }
})();
